import { render, staticRenderFns } from "./QuoteListView.vue?vue&type=template&id=ce66673c&scoped=true"
import script from "./QuoteListView.vue?vue&type=script&lang=js"
export * from "./QuoteListView.vue?vue&type=script&lang=js"
import style0 from "./QuoteListView.vue?vue&type=style&index=0&id=ce66673c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce66673c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce66673c')) {
      api.createRecord('ce66673c', component.options)
    } else {
      api.reload('ce66673c', component.options)
    }
    module.hot.accept("./QuoteListView.vue?vue&type=template&id=ce66673c&scoped=true", function () {
      api.rerender('ce66673c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteListView.vue"
export default component.exports